import Modal from '@/app-components/Modal.vue'
import AppFrame from '@/app-components/AppFrame.vue'
import Spinner from '@/app-components/UIComponents/Spinner.vue'

export default [
  Spinner,
  {
    name: 'Modal',
    component: Modal
  },
  {
    name: 'AppFrame',
    component: AppFrame
  }
]

